import Input from "components/common/input";
import { ErrorMessage, Formik } from "formik";
import * as yup from "yup";

const resetPasswordSchema = yup.object().shape({
  password: yup.string().required("New Password is required *"),

  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Passwords must match")
    .required("Confirm Password is required *"),
});

const ChangePasswordForm = ({
  handleSubmit,
  handleClose,
  currentOutreachStaffEdit = {},
}) => {
  const { first_name, last_name, email } = currentOutreachStaffEdit;
  return (
    <Formik
      initialValues={{ password: "", confirmPassword: "" }}
      validationSchema={resetPasswordSchema}
      onSubmit={(values) => {
        handleSubmit(values);
      }}
    >
      {({ handleChange, values, handleSubmit }) => {
        return (
          <div className="question-modal">
            <hr className="custom-modal-line mt-0 " />
            <div className="d-flex justify-content-center">
              <p>
                <b>Name:</b> {first_name} {last_name}
                <br></br>
                <b> Username:</b> {email}
                <br></br>
                <b>Email:</b> {email}
              </p>
            </div>

            <form className="form-main" onSubmit={handleSubmit}>
              <Input
                handleChange={handleChange}
                placeholder="Password"
                type="password"
                label="New Password"
                value={values.password}
                name="password"
                className="mb-1"
                error={
                  <ErrorMessage
                    className="error-message"
                    component="p"
                    name="password"
                  />
                }
              />
              <Input
                handleChange={handleChange}
                placeholder="Confirm password"
                type="password"
                label="Confirm Password"
                value={values.confirmPassword}
                name="confirmPassword"
                className="mb-1"
                error={
                  <ErrorMessage
                    className="error-message"
                    component="p"
                    name="confirmPassword"
                  />
                }
              />

              <hr className="custom-modal-line mt-4" />

              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <input
                  className="primary-btn w-50"
                  type="submit"
                  name="submit"
                  value={"Change Password"}
                />
              </div>
            </form>
          </div>
        );
      }}
    </Formik>
  );
};

export default ChangePasswordForm;
